import { routingFormOptions as salesforce_routing_form_schema } from "../salesforce/zod";

export const routingFormAppDataSchemas = {
  salesforce: salesforce_routing_form_schema,
};
